/**
 * API配置文件
 */

/**
 * 音频文件基础域名
 */
export const AUDIO_BASE_URL = 'https://aiaudio.hqrhtech.com'

/**
 * API超时配置
 */
export const TIMEOUT_CONFIG = {
  DEFAULT: 30000,
  AUDIO: 60000
}

